// extracted by mini-css-extract-plugin
export default {"reactAppId":"App_reactAppId__ok3gL"};